import React from 'react'
import ReactDOM from 'react-dom/client'
import reportWebVitals from './reportWebVitals'
import Root from './app/Root'

import './assets/scss/theme.scss'
import './assets/scss/preloader.scss'

import './shared/service/axios'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
)

reportWebVitals()
